import { render } from "./editPasswordDialog.vue?vue&type=template&id=34cba540&ts=true"
import script from "./editPasswordDialog.vue?vue&type=script&lang=ts"
export * from "./editPasswordDialog.vue?vue&type=script&lang=ts"

import exportComponent from "F:\\工作\\project\\kaola\\kaola-project-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__